import sticky_footer_cta_init from './sticky_footer_cta/init';

export default function footer_init() {
    
    sticky_footer_cta_init();
    scroll_to_top_btn_init();

    document.addEventListener('after_main_init', ()=>{
        close_footer_dropdowns();
    })
}

function scroll_to_top_btn_init(){
    const btn = document.querySelector('.scroll_to_top_btn');
    if( !btn ) return;
    btn.addEventListener('click', ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    })
}

function close_footer_dropdowns(){
    if( window.innerWidth > 768 ) return;
    document.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open').forEach(dropdown=>{
        dropdown.click();
    })
}